import { TestQuestionsView } from 'pages/custom_tests/components/custom_test_edit/components/TestQuestionsView';
import { useCustomTestEdit } from 'pages/custom_tests/components/custom_test_edit/context';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { CUSTOM_TESTS_V2_BASE } from 'pages/custom_tests/types';
import { useLocation, useNavigate } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

export const QuestionsTab = props => {

    const { confirmCopy, editable, isOwner, loadingQuestions, questionsError, questionTree, retryQuestions, selectedQuestionIds, testId } = useCustomTestEdit();
    const { formatMessage } = useIntl();
    const navigate = useNavigate();
    const fromLookup = (useLocation().state as { from?: string } | null)?.from;

    const selectedCount = selectedQuestionIds.split(',').map(s => s.trim()).filter(Boolean).length;
    const treeLoaded = (questionTree.Products?.length ?? 0) > 0;

    if (!loadingQuestions && questionsError) {

        return (
            <div className="questions-tab">
                <div className="d-flex flex-column align-items-center text-center py-5">
                    <i className="fa-regular fa-circle-exclamation fs-1 text-danger mb-3" />
                    <h5 className="fw-bold mb-3">
                        <FormattedMessage defaultMessage="Failed to load questions." id="failed_to_load_questions.82bf5a85" />
                    </h5>
                    <GMetrixButton
                        iconClass="fa-solid fa-arrow-rotate-right"
                        onClick={retryQuestions}
                        variant="primary"
                    >
                        <FormattedMessage defaultMessage="Retry" id="retry.225ca180" />
                    </GMetrixButton>
                </div>
            </div>
        );

    }

    return (
        <div className="questions-tab">
            {loadingQuestions || (selectedCount > 0 && !treeLoaded) ?
                (
                    <div className="d-flex align-items-center justify-content-center p-5">
                        <GMetrixLoader size="large" />
                    </div>
                )
                : treeLoaded ?
                    (
                        <TestQuestionsView questionTree={questionTree} selectedIds={selectedQuestionIds} />
                    )
                    :
                    (
                        <div className="d-flex flex-column align-items-center text-center py-5">
                            <i className="fa-regular fa-circle-exclamation fs-1 text-muted mb-3" />
                            <h5 className="fw-bold mb-1">
                                {/* lblNoQuestionsAvailable is the wizard's "select products first" string — wrong context here. */}
                                {isOwner
                                    ? (formatMessage({ id: 'no_questions_available.ba8131b3', defaultMessage: 'No Questions Available' }))
                                    : (formatMessage({ id: 'questions_unavailable.1f453861', defaultMessage: 'Questions Unavailable' }))}
                            </h5>
                            {editable && isOwner ?
                                (
                                    <>
                                        <p className="text-muted mb-3">
                                            <FormattedMessage defaultMessage="This Custom Test does not currently have available questions. Edit the test in order to add available questions" id="this_custom_test_does_not_currently_have.c4d6d880" />
                                        </p>
                                        <GMetrixButton
                                            iconClass="fa-solid fa-pen"
                                            onClick={() => navigate(`${CUSTOM_TESTS_V2_BASE}/build/${testId}`, { state: { from: fromLookup } })}
                                            variant="primary"
                                        >
                                            <FormattedMessage defaultMessage="Edit" id="edit.00978daf" />
                                        </GMetrixButton>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <p className="text-muted mb-3">
                                            {isOwner
                                                ? (formatMessage({ id: 'this_custom_test_does_not_currently_have.3570a5e3', defaultMessage: 'This Custom Test does not currently have available questions. Copy and edit this test in order to add available questions' }))
                                                : (formatMessage({ id: 'this_test_was_created_by_another_user_co.980d55a4', defaultMessage: 'This test was created by another user. Copy it to build an editable version of your own.' }))}
                                        </p>
                                        <GMetrixButton
                                            iconClass="fa-regular fa-copy"
                                            onClick={confirmCopy}
                                            variant="primary"
                                        >
                                            <FormattedMessage defaultMessage="Copy and Edit" id="copy_and_edit.9b9cf664" />
                                        </GMetrixButton>
                                    </>
                                )}
                        </div>
                    )
            }
        </div>
    );

};